import React, { ReactNode } from "react";

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: ReactNode;
  hideArrow?: boolean;
}

const GradientButton: React.FC<ButtonProps> = ({
  children,
  className = "",
  // Destructure `hideArrow` so it is consumed here and not spread onto
  // the DOM `<button>` (React would warn about an unknown attribute).
  // It currently has no visual side effect — the arrow render is
  // commented out below — but we keep the prop in the public API.
  hideArrow,
  ...props
}) => {
  void hideArrow;
  return (
    <button
      {...props}
      className={`inline-flex items-center  active:scale-95 hover:bg-primary-color scale-100  justify-center px-6  py-2 bg-primary/80 text-white font-medium rounded-full  transition-all duration-300 hover:shadow-[0_0_20px_#846dff] cursor-pointer shadow-[0_0_15px_#846dff] ${className}`}
    >
      {children}
      {/* {!_hideArrow && <span className="ml-2">↗</span>} */}
    </button>
  );
};

export default GradientButton;
